import { GridApi } from '@ag-grid-community/core'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { AccountListAggregate } from '@helios/generic-components'
import { Observable } from 'rxjs'
import { delay, filter, mergeAll, tap, toArray } from 'rxjs/operators'
import { AccountListService } from '../../services/account-list.service'

// export type size = 'lg' | 'md' | 'sm'
@Component({
  selector: 'hs-account-list-aggregate-dropdown',
  templateUrl: './account-list-aggregate-dropdown.component.html',
  styleUrls: ['./account-list-aggregate-dropdown.component.scss'],
})
export class AccountListAggregateDropdownComponent {
  aggregates?: Observable<AccountListAggregate[]>
  gridApi?: GridApi
  showLoader = false

  @Input() parentPortfolioId?: number
  @Input() set accountId(value: number) {
    this.showLoader = true
    this.aggregates = this.service.getAggregates(value).pipe(
      delay(300),
      tap((aggregateAccounts: AccountListAggregate[]) => {
        this.showLoader = false
        const correctHeight =
          document.body.offsetHeight -
          this.elRef.nativeElement.parentElement.offsetTop -
          this.elRef.nativeElement.parentElement.offsetHeight
        if (correctHeight <= aggregateAccounts.length * 26) {
          this.elRef.nativeElement.style.height = `${correctHeight}px`
        }
      }),
      mergeAll(),
      filter(
        agg =>
          this.parentPortfolioId == null ||
          agg.accountId !== this.parentPortfolioId,
      ),
      toArray(),
    )
  }

  @Output() aggregateIdChanged = new EventEmitter<number>()

  constructor(
    private readonly service: AccountListService,
    private readonly elRef: ElementRef,
  ) {}

  onClick(aggregate: AccountListAggregate) {
    this.aggregateIdChanged.next(aggregate.accountId)
  }
}
